import { Injectable } from "@nestjs/common";
import { InjectRepository } from "@nestjs/typeorm";
import { EmployeeEntity } from "./employee.entity";
import { DataSource, Repository } from "typeorm";
import { CommonResponseModel, departmentIdReq, EmployeeId, PlantIdReq } from "@project-management-system/shared-models";
import { EmployeeDto } from "./employee.dto";
import { ErrorResponse } from "packages/libs/backend-utils/src/models/global-res-object";
import { EmployeePhoneNoReq } from "./employee-phone-no.req";
import { GenericTransactionManager } from "packages/services/common/src/typeorm-transactions";
// import * as mysql from 'mysql2/promise'; 
// import { OkPacket, createConnection } from 'mysql2/promise';
// import * as bcrypt from 'bcryptjs';

@Injectable()
export class EmployeeService {
    constructor(
        @InjectRepository(EmployeeEntity)

        private repo: Repository<EmployeeEntity>,
        private readonly dataSource: DataSource,

    ) { }

    async createEmployee(req: EmployeeDto): Promise<CommonResponseModel> {

        try {
            // const Check = await this.repo.find({ where: { employeeName: req.employeeName, contactNumber: req.contactNumber } })
            // if (Check.length > 0) {
            //     return new CommonResponseModel(false, 0, 'Employee Name already exists')
            // }
            const check = await this.repo.find({ where: { employeeName: req.employeeName}||{ contactNumber: req.contactNumber}  });
            if (check.length > 0) {
                return new CommonResponseModel(false, 0, 'employee Name already exists');
            }

            const entity = new EmployeeEntity()
            entity.employeeName = req.employeeName
            entity.employeeCode = req.employeeCode
            entity.departmentName = req.departmentName
            entity.division = req.division
            entity.unit = req.unit
            entity.role = req.role
            entity.refNo = req.refNo
            entity.address = req.address
            entity.gpsLocation = req.gpsLocation
            entity.plantId = req.plantId
            // entity.noofpeople = req.noofpeople
            // entity.to = req.to
            // entity.from = req.from
            entity.createdUser = req.createdUser;
            entity.isActive = req.isActive;
            entity.versionFlag = req.versionFlag;
            entity.updatedUser = req.updatedUser;

            if (req.id) {
                entity.contactNumber = req.contactNumber
                entity.updatedUser = req.createdUser

            } else {
                entity.contactNumber = req.contactNumber
                entity.createdUser = req.createdUser
            }
            const save = await this.repo.save(entity)
            if (!save) {

                return new CommonResponseModel(false, 0, 'Something went wrong in Employee creation', [])
            } else {

                return new CommonResponseModel(true, 1, 'Created successfully', save)
            }

        } catch (err) {

            throw err
        }
    }


    async getAllEmployee(req:departmentIdReq): Promise<CommonResponseModel> {
        console.log(req.plant,'ssssssssssssssss')
        // const data = `SELECT emp.employee_name AS employeeName , emp.department_name AS departmentName, emp.division AS division, emp.unit AS unit, emp.role AS role, emp.refNo AS refNo, emp.contact_number AS contactNumber,emp.is_active AS isActive,emp.version_flag AS versionFlag, dep.department_name AS dep_name
        // FROM employee emp LEFT JOIN department dep ON dep.id = emp.department_name`

        let data = `SELECT emp.employee_code AS employeeCode,emp.email_id AS email,emp.id AS id,emp.employee_name AS employeeName ,emp.department_name AS departmentName, emp.role ,emp.division AS division, emp.unit AS unit, 
        emp.refNo AS refNo, emp.contact_number AS contactNumber, emp.address AS address, emp.gps_location AS gpsLocation, emp.is_active AS isActive,emp.version_flag AS versionFlag,p.plant_id AS plantId,p.plant_name AS plantName,
         dep.department_name AS departmentName1, rl.role AS roleName,d.division as divisionName
                FROM employee emp LEFT JOIN department dep ON dep.id = emp.department_name
                LEFT JOIN roles rl ON rl.id = emp.role 
                LEFT JOIN plants p on p.plant_id = emp.plant_id
                left join division d on d.id =emp.division where emp.id >0
                `
                if(req.departmentId != undefined){
                    data=data+` and emp.department_name=${req.departmentId}`
                }
                if (req.plant && req.plant !== 'ALL') {
                    data += ` and p.plant_name = '${req.plant}'`;
                  }
                  
        const record = await this.dataSource.query(data);

        if (record.length > 0) {
            return new CommonResponseModel(true, 1, 'data retrived Sucessfully', record)
        }
        return new CommonResponseModel(true, 1, 'data retrived Sucessfully', [])
    } catch(err) {
        return err;
    }

    async getActiveAllEmployee(): Promise<CommonResponseModel> {
        const data = await this.repo.find({
            where: {
                isActive: true
            }
        })

        if (data.length > 0) {
            return new CommonResponseModel(true, 1, 'data retrived Sucessfully', data)
        }
        return new CommonResponseModel(true, 1, 'data retrived Sucessfully', [])
    }


    async getEmployeeById(req: EmployeeId): Promise<CommonResponseModel> {
        try{
            let data = await this.repo.findOne({where:{id:req.id}});
            if(data.id >0){
                return new CommonResponseModel(true, 1, 'data retrived Sucessfully', data)
            }
            else{
                return new CommonResponseModel(false, 0, 'No data found', [])
            }
        }catch (error) {
            console.log(error);
        }
    }

    async updateEmployee(req: EmployeeDto): Promise<CommonResponseModel> {
        console.log("updateemployee==", req)

        try {
            let Product;
            Product = await this.repo.update(
                { id: req.id },
                {
                    employeeName: req.employeeName,
                    employeeCode: req.employeeCode,
                    departmentName: req.departmentName,
                    division: req.division, /*from: req.from, to: req.to,*/
                    unit: req.unit,
                    role: req.role,
                    refNo: req.refNo, contactNumber: req.contactNumber,
                    address: req.address,
                    gpsLocation: req.gpsLocation /*noofpeople: req.noofpeople*/
                }
            )
            if (Product.affected > 0) {
                return new CommonResponseModel(true, 11, 'updated successfully', Product);
            }
            else {
                return new CommonResponseModel(false, 11, 'uploaded failed', []);
            }
        }
        catch (error) {
            console.log(error);
        }
    }

    async activateOrDeactivateEmployee(req: EmployeeDto): Promise<CommonResponseModel> {
        try {
            console.log(req.isActive, 'service-----------')
            const Exists = await this.repo.findOne({ where: { id: req.id } });
            if (Exists) {
                if (!Exists) {
                    throw new ErrorResponse(10113, 'Someone updated the current Employee information.Refresh and try again');
                } else {

                    const update = await this.repo.update(
                        { id: req.id },
                        { isActive: req.isActive, updatedUser: req.updatedUser });
                    if (Exists.isActive) {
                        if (update.affected) {
                            const Response: CommonResponseModel = new CommonResponseModel(true, 10115, 'Employee is Deactivated successfully');
                            return Response;
                        } else {
                            throw new CommonResponseModel(false, 10111, 'Employee is already deactivated');
                        }
                    } else {
                        if (update.affected) {
                            const Response: CommonResponseModel = new CommonResponseModel(true, 10114, 'Employee is activated successfully');
                            return Response;
                        } else {
                            throw new CommonResponseModel(false, 10112, 'Employee is already  activated');
                        }
                    }

                }
            } else {
                throw new CommonResponseModel(false, 99998, 'No Records Found');
            }
        } catch (err) {
            return err;
        }
    }

    async getEmployeeDashBoard(): Promise<CommonResponseModel> {
        const query = ` SELECT 
        SUM(CASE WHEN emp.is_active = 1 THEN 1 ELSE 0 END) AS Active,
        SUM(CASE WHEN emp.is_active = 0 THEN 1 ELSE 0 END) AS Inactive
    FROM 
        employee emp;`;
        const result = await this.repo.query(query);
        if (result) {
            return new CommonResponseModel(true, 1, "Data Retrived", result);
        } else {
            return new CommonResponseModel(false, 0, "Data Retrived");
        }
    }

    async getHods(): Promise<CommonResponseModel>{
        try{
            const result = await this.repo.query(
                `SELECT 
                    emp.id AS id,
                    emp.employee_name AS employeeName,
                    emp.employee_code AS employeeCode
                FROM 
                    employee emp 
                LEFT JOIN 
                    roles r ON r.id = emp.role
                WHERE 
                    emp.is_active = 1 
                    AND r.role = 'HOD'`
            );
            return new CommonResponseModel(true, 1, "Data Retrived", result);
        } catch(error){
            return new CommonResponseModel(false, 0, "Data Retrived");
        }
    }

      async getNonHods(): Promise<CommonResponseModel> {
        const query = `SELECT r.role,emp.id AS id,employee_name AS employeeName, employee_name AS employeeCode, emp.department_name AS department, code AS employeeCode
        FROM employee emp left join roles r on r.id = emp.role
        WHERE emp.is_active = 1 and r.role != 'HOD' order by employee_name ASC `;        
        const result = await this.repo.query(query);
        if (result) {
          return new CommonResponseModel(true, 1, "Data Retrived", result);
        } else {
          return new CommonResponseModel(false, 0, "Data Retrived");
        }
      }


      async getNonHodsByPlant(req:PlantIdReq): Promise<CommonResponseModel> {
        const query = `SELECT r.role,emp.id AS id,employee_name AS employeeName, employee_name AS employeeCode, emp.department_name AS department, code AS employeeCode
        FROM employee emp left join roles r on r.id = emp.role
        WHERE emp.plant_id = ${req.plantId} and emp.is_active = 1 and r.role != 'HOD' order by employee_name ASC `;        
        const result = await this.repo.query(query);
        if (result) {
          return new CommonResponseModel(true, 1, "Data Retrived", result);
        } else {
          return new CommonResponseModel(false, 0, "Data Retrived");
        }
      }


      

      async checkIfEmployeeExist(req : EmployeePhoneNoReq){
        const query = `SELECT emp.id AS id,employee_name AS employeeName, employee_name AS employeeCode, emp.department_name AS department, p.plant_id AS plantId, p.plant_name AS plantName FROM employee emp left join roles r on r.id = emp.role left join plants p on p.plant_id = emp.plant_id WHERE emp.is_active = 1 and emp.contact_number ='`+req.contactNumber+`' and r.role='L1' `;        
        const data = await this.repo.query(query);
        console.log(data);
        if(data.length >0){
            return {isEmployeeExist : true,employeeDetails : data}
        }else{
            return {isEmployeeExist : false,employeeDetails : null}
        }
    }
    async getHodDetailsByEmp(req : EmployeePhoneNoReq){
        const query = `SELECT ep.id AS id,ep.employee_name AS employeeName,employee_name AS employeeCode, ep.contact_number AS contact, p.plant_id AS plantId, p.plant_name AS plantName FROM employee emp left join department dp on dp.id = emp.department_name left join employee ep on ep.id = dp.hod_id left join plants p on p.plant_id = emp.plant_id WHERE emp.is_active = 1 and emp.contact_number ='`+req.contactNumber+`'`;        
        const data = await this.repo.query(query);
        console.log(data);
        if(data){
            return {isEmployeeExist : true,employeeDetails : data}
        }else{
            return {isEmployeeExist : false,employeeDetails : null}
        }
    }


    // employee dump & user creation dont delete
    // async createEmloyeeAndUser(formData: any) {
    //     const transactionManager = new GenericTransactionManager(this.dataSource);
    
    //     try {
    //         await transactionManager.startTransaction();
    //         const flag = new Set();
    //         // const updatedArray = formData.map((obj) => {
    //         //     const updatedObj = {};
    //         //     for (const key in obj) {
    //         //         const newKey = key.replace(/\s/g, '_').replace(/[\(\)]/g, '').replace(/-/g, '_');
    //         //         updatedObj[newKey] = obj[key];
    //         //     }
    //         //     return updatedObj;
    //         // });
    
    //         // const convertedData = updatedArray.map((obj) => {
    //         //     const updatedObj = {};
    //         //     for (const key in obj) {
    //         //         const value = obj[key];
    //         //         if (value === "") {
    //         //             updatedObj[key] = null;
    //         //         } else {
    //         //             const regexPattern = /[^A-Za-z0-9 -;:/.,()[]&_']/g;
    //         //             updatedObj[key] = value.replace(regexPattern, '');
    //         //             updatedObj[key] = Buffer.from(value, 'utf-8').toString();
    //         //         }
    //         //     }
    //         //     return updatedObj;
    //         // });
    //         const convertedData = await this.repo.find({where:{division:7}});
    
    //         const connection = await createConnection({
    //             host: "165.22.220.143",
    //             user: "ramakrishna",
    //             password: "Schemax@23",
    //             database: "shahi_users"
    //         });
    
    //         for (const data of convertedData) {
    //             if (data.employeeName != null) {
    //                 // let empEntity = new EmployeeEntity();
    //                 // empEntity.address = "";
    //                 // empEntity.contactNumber = data.MOBILE;
    //                 // empEntity.departmentName = data.DEPARTMENT;
    //                 // empEntity.division = "DIV1";
    //                 // empEntity.employeeName = data.NAME;
    //                 // empEntity.role = 5;
    //                 // empEntity.unit = "Unit 7";
    //                 // empEntity.accessNo = data.ACCESSNO;
    //                 // empEntity.code = data.CODE;
    //                 // empEntity.designation = data.DESIGNATION;
    //                 // empEntity.factoryCode = data.FACTORYCODE;
    //                 // empEntity.reportingHeadEmailId = data.REPORTINGHEADEMAILID;
    //                 // empEntity.emailId = data.EMAILID;
    
    //                 // const saveEmployee = await transactionManager.getRepository(EmployeeEntity).save(empEntity);
    //                 // if (!saveEmployee) {
    //                     // console.log("hello")
    //                     // flag.add(false);
    //                     // await transactionManager.releaseTransaction();
    //                     // return new CommonResponseModel(false, 0, 'Failed to save employee data.');
    //                 // }
    
    //                 let hashedPsw
    //                 let salt

    //                 const plaintextPassword = data.contactNumber;
    //                    await this.hashPassword(plaintextPassword)
    //                         .then((hashedPassword) => {
    //                             console.log('Hashed Password:', hashedPassword.data);
    //                             hashedPsw = hashedPassword.data;
    //                             salt = hashedPassword.data1
    //                         })
    //                         .catch((error) => {
    //                             console.error('Error:', error.message);
    //                         }); 
    //                 // const [rows] = await connection.execute("SELECT first_name FROM users WHERE id = 211");
    //                 // console.log(rows);
    //                 const [authQueryResult] = await connection.execute<OkPacket>(
    //                     "INSERT INTO authentications (uuid,email, username, password,salt) VALUES ('54baa4a1-f6d4-42e9-9707-dca2af120542',?, ?, ?,?)",
    //                     [data.emailId, data.employeeName, hashedPsw,salt]
    //                 );  
    //                 console.log(authQueryResult);
    
    //                 const authId = authQueryResult.insertId;
    
    //                 const [userQueryResult] = await connection.execute<OkPacket>(
    //                     "INSERT INTO users (uuid,first_name, last_name, mobile_no, gender, identity_type, identity_no, authentication_id, unit_id, client_id, external_ref_no) VALUES ('2eddbffd-ccec-421b-9847-c7fbd153e0d7',?, ?, ?, 'MALE', 'AADHAR', '1111111111111111', ?, 1, 1, ?)",
    //                     [data.employeeName, data.employeeName, data.contactNumber, authId, data.id]
    //                 );
    //                 console.log(userQueryResult);
    //                 const [userRoleQueryResult] = await connection.execute<OkPacket>(
    //                     "INSERT INTO user_roles (uuid,created_user, user_id, role_id) VALUES ('2eddbffd-ccec-421b-9847-c7fbd153e0d7','Admin', ?, '75')",
    //                     [userQueryResult.insertId]
    //                 );
    //                 console.log(userRoleQueryResult);

    //                 // if (!rows || rows.length === 0) {
    //                 //     flag.add(false);
    //                 // }
    //             }
    //         }
    
    //         if (flag.has(false)) {
    //             await transactionManager.releaseTransaction();
    //             return new CommonResponseModel(false, 0, 'Something went wrong.');
    //         } else {
    //             await transactionManager.completeTransaction();
    //             return new CommonResponseModel(true, 1, 'Data saved successfully');
    //         }
    //     } catch (err) {
    //         await transactionManager.releaseTransaction();
    //         return new CommonResponseModel(false, 0, err.message || err);
    //     }
    // }
    // employee dump & user creation dont delete
    // async hashPassword(plaintextPassword: string) {
    //     try {
    //         const saltRounds = 10; // Recommended number of rounds
    //         const salt = await bcrypt.genSalt(saltRounds);
    //         const hashedPassword = await bcrypt.hash(plaintextPassword, salt);
    //         // return [hashedPassword,salt];
    //         return new CommonResponseModel(true,1,"",hashedPassword,salt)
    //     } catch (error) {
    //         throw new Error(error);
    //     }
    // }


    // async updatePassword(): Promise<CommonResponseModel>  {
    //     try{
    //         const connection = await createConnection({
    //             host: "165.22.220.143",
    //             user: "ramakrishna",
    //             password: "Schemax@23",
    //             database: "shahi_users"
    //         });
    //         const [rows] = await connection.execute<mysql.RowDataPacket[]>("SELECT authentication_id,id,first_name,REPLACE(mobile_no, ' ', '') AS mobile_no FROM users WHERE id BETWEEN 212 AND 983;");
    //         console.log(rows);
    //         console.log(rows[0].mobile_no)

    //         let hashedPsw
    //         let salt
    //         for (const data of rows) {
    //             console.log(data);
    //             console.log("***************")

    //             const plaintextPassword = data.mobile_no;
    //             await this.hashPassword(plaintextPassword)
    //                     .then((hashedPassword) => {
    //                         console.log('Hashed Password:', hashedPassword.data);
    //                         console.log('salt:', hashedPassword.data1);

    //                         hashedPsw = hashedPassword.data;
    //                         salt = hashedPassword.data1
    //                     })
    //                     .catch((error) => {
    //                         console.error('Error:', error.message);
    //                     }); 
    //             const [rows] = await connection.execute<mysql.RowDataPacket[]>("UPDATE authentications set salt = '"+salt+"',password = '"+hashedPsw+"' where id ="+data.authentication_id);
    //             console.log(rows);
    //         }
    //         return new CommonResponseModel(true,1,"",rows);
    //     }catch (error) {
    //         throw new Error(error);
    //     }
    // }

}